import script from "./EditDocuments.vue?vue&type=script&setup=true&lang=js"
export * from "./EditDocuments.vue?vue&type=script&setup=true&lang=js"

import "./EditDocuments.vue?vue&type=style&index=0&id=1f54d231&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f54d231"]])

export default __exports__